import React from 'react'
import './paginationLoader.sass'

const PaginationLoader = ({ white }: { white?: boolean }) => {
    return <div className={`paginationLoader${white ? ' whitePaginationLoader' : ''}`}></div>
}

export default PaginationLoader
